var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCog = function SvgCog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2 6.073V9.92c0 1.413 0 1.413 1.333 2.313L7 14.353c.553.32 1.453.32 2 0l3.667-2.12C14 11.333 14 11.333 14 9.926V6.073c0-1.407 0-1.407-1.333-2.307L9 1.646c-.547-.32-1.447-.32-2 0l-3.667 2.12C2 4.666 2 4.666 2 6.073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export { SvgCog as ReactComponent };
export default __webpack_public_path__ + "fa3ae36b121ddb874ed0e9deb52801ea.svg";